export default __webpack_public_path__ + "static/media/cx.c143c5c4.svg";